import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';

const AdminActions = ({ isOpen, onClickOpen, onClose, position }) => {
  const renderItems = () => {
    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';
    const viewUser = <span className={className}>View User Details</span>;
    const deleteUser = <span className={className}>Delete</span>;

    let options = [viewUser, deleteUser];

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

AdminActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
};
AdminActions.defaultProps = {
  position: 'bottom',
};

export default memo(AdminActions);
